import React from 'react';
import { useSelector } from 'react-redux';

import Icon from 'components/DesignSystem/Icon';
import SubtitleSemiBold from 'components/Typography/SubtitleSemiBold';
import BodyRegular from 'components/Typography/BodyRegular';

import { selectUserIsAdmin } from 'redux/reducers/authReducer';
import { DESSEM_APROVACAO_CINZA_EVENTO } from 'constants/colors';
import { labelDaVariante } from 'helper/Relatorios/Aprovacao';
import { getAprovacaoConfig } from 'helper/Relatorios/Aprovacao/config';
import { rotuloDataDoInforme } from 'helper/Relatorios/Dessem';
import { DessemSecaoParams } from 'types/Relatorios/Dessem';

import './index.scss';

const config = getAprovacaoConfig('dessem');

export const TEXTO_SEM_INFORME_ADMIN = 'O Core ainda não tem estudo deste dia e cenário; '
  + 'o informe aparece quando o primeiro estudo chega.';
export const TEXTO_SEM_INFORME_CLIENTE = 'Este dia ainda não tem informe publicado.';

/** Título do estado vazio: `Sem informe de 13/10/2026 (previsão para 14/10) · Early`. */
export const tituloSemInforme = (
  { data_rodada: dataRodada, cenario }: DessemSecaoParams,
): string => (
  `Sem informe de ${rotuloDataDoInforme(dataRodada)} · ${labelDaVariante(config, cenario)}`
);

export interface SemInformeProps {
  params: DessemSecaoParams;
}

/**
 * Estado vazio de uma seção do DESSEM num dia/cenário sem estudo (404 do backend), no estilo
 * do `ClienteNaoPublicado`. O admin lê por que (o Core ainda não tem o estudo); o cliente, só
 * que o dia não tem informe publicado.
 */
export default function SemInforme({ params }: SemInformeProps) {
  const isAdmin = useSelector(selectUserIsAdmin);

  return (
    <div className="dessem-secao-sem-informe">
      <span className="dessem-secao-sem-informe__icone" aria-hidden="true">
        <Icon iconType="calendar" color={DESSEM_APROVACAO_CINZA_EVENTO} />
      </span>
      <SubtitleSemiBold>{tituloSemInforme(params)}</SubtitleSemiBold>
      <BodyRegular>{isAdmin ? TEXTO_SEM_INFORME_ADMIN : TEXTO_SEM_INFORME_CLIENTE}</BodyRegular>
    </div>
  );
}
